import { format } from "date-fns"

const updateBuilderSettingsAt = () => {
  return `All changes saved at ${format(Date.now(), 'h:mm a')}`
}

export default updateBuilderSettingsAt